<template>
  <div
    :class="`vmp-privacy-compliance scene_${scene} client_${clientType} ${
      $i18n.locale == 'en' ? 'language__en' : ''
    }`"
    v-if="!isEmbed || module == 2 || module == 3"
  >
    <vh-checkbox
      v-if="compType == 1"
      v-model.trim="isCheck"
      @change="emitCheckboxVal"
    ></vh-checkbox>
    <!--a 不能格式化，格式化会多空格 -->
    <template v-if="isCustom">
      <span v-html="customHtm"></span>
    </template>
    <template v-else>
      <i18n v :path="compType == 1 ? 'privacy.privacy_1001' : 'privacy.privacy_1002'">
        <span place="n">
          <a :href="privacyUrl" target="_blank" rel="noopener noreferrer">
            {{ $t('privacy.privacy_1004') }}
          </a>
        </span>
        <span place="n1">
          <a :href="privacyUPoUrl" target="_blank" rel="noopener noreferrer">
            {{ $t('privacy.privacy_1003') }}
          </a>
        </span>
      </i18n>
    </template>
  </div>
</template>
<script>
  import { v1 as uuidV1 } from 'uuid';
  import to from 'await-to-js';
  import { usePrivacyAgreementServer } from 'middle-domain';
  import { source } from 'postcss-pxtorem/lib/pixel-unit-regex';
  export default {
    name: 'VmpPrivacyCompliance',
    data() {
      return {
        isCheck: false,
        privacyUrl: `${window.location.protocol}${process.env.VUE_APP_WEB_BASE}${process.env.VUE_APP_WEB_KEY}/privacyPolicy`,
        privacyUPoUrl: `${window.location.protocol}${process.env.VUE_APP_WEB_BASE}${process.env.VUE_APP_WEB_KEY}/privacyUPo`,

        // 是否使用自定义隐私协议
        isCustom: false,
        // 自定义隐私协议文本内容
        customContent: '',
        // 自定义隐私协议关键词和链接
        // title，link
        customInfo: []
      };
    },
    computed: {
      isEmbed() {
        return this.$domainStore.state.roomBaseServer.embedObj.embed;
      },
      customHtm() {
        if (this.customInfo.length === 1) {
          // 只有一个隐私协议直接替换
          return this.customContent.replace(
            this.customInfo[0].title,
            `<a href="${this.customInfo[0].link || 'javascript:void(0);'}" target="${
              this.customInfo[0].link ? '_blank' : '_self'
            }" rel="noopener noreferrer">${this.customInfo[0].title}</a>`
          );
        } else {
          // 有多个隐私协议的处理
          let htm = this.customContent;
          for (const item of this.customInfo) {
            item.uuid = uuidV1(); // 先替换为占位符，保证唯一
            htm = htm.replace(item.title, item.uuid);
          }
          for (const item of this.customInfo) {
            htm = htm.replace(
              item.uuid,
              `<a href="${item.link || 'javascript:void(0);'}" target="${
                item.link ? '_blank' : '_self'
              }" rel="noopener noreferrer">${item.title}</a>`
            );
          }
          return htm;
        }
      }
    },
    props: {
      scene: {
        type: String,
        default: 'default'
      },
      clientType: {
        type: String,
        default: 'pc' // PC-网页；mobile - 手机端
      },
      compType: {
        type: [Number, String],
        default: 1 // 1-有勾选；2-无勾选（提交及统一）
      },
      module: {
        type: [Number, String], // 所属模块： 1 活动观看限制 2 抽奖 3 互动有礼
        default: null
      },
      sourceId: {
        type: [Number, String], //模块记录 id, 如：抽奖 id';
        default: null
      }
    },
    beforeCreate() {
      this.privacyAgreementServer = usePrivacyAgreementServer();
    },
    methods: {
      emitCheckboxVal(val) {
        if (this.compType == 1) {
          this.$emit('check', {
            checked: val,
            scene: this.scene
          });
        }
      },
      // 重置选中状态
      resetChecked() {
        this.isCheck = false;
      },
      // 获取隐私协议数据
      async getPrivacyAgreement() {
        const [err, res] = await to(
          this.privacyAgreementServer.getPrivacyAgreement(this.module, this.sourceId)
        );
        if (err || !res || res.code != 200) {
          // this.$message.error(err.msg || res?.msg || '请求出现异常');
          return false;
        }
        this.isCustom = !!res.data.statement_status;
        this.customContent = res.data.statement_content || '';
        this.customInfo = res.data.statement_info || [];
      },
      // 重新初始化隐私协议数据
      reInit(privacyData = {}) {
        this.isCustom = privacyData.isCustom;
        this.customContent = privacyData.customContent || '';
        this.customInfo = privacyData.customInfo || [];
      }
    },
    mounted() {
      if (this.module && this.sourceId) {
        // 获取隐私协议数据
        this.getPrivacyAgreement();
      }
    }
  };
</script>
<style lang="less">
  .vmp-privacy-compliance {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    .vh-checkbox {
      margin-right: 8px;
    }
    span,
    a {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      word-break: break-word;
    }
    span {
      color: #8c8c8c;
    }
    a {
      text-decoration: none;
      color: #3562fa;
      transform: matrix(0.99, 0, -0.14, 1, 0, 0);
      &:hover {
        color: #3562fa;
      }
    }
    /* 观看端-登录：展开其它登录方式 */
    &.scene_login {
      line-height: 16px;
      margin-top: 12px;
      align-items: baseline;
      padding-bottom: 2px;
    }
    &.scene_loginDynamic {
      line-height: 16px;
      margin-top: 12px;
      align-items: baseline;
      padding-bottom: 2px;
    }
    /* 观看端-注册 */
    &.scene_register {
      margin-top: 38px;
    }
    /* 观看端-抽奖 */
    &.scene_lottery {
      display: block;
      text-align: left;
      align-items: unset;
      justify-content: unset;
    }
    /* 观看端-鉴权白名单 */
    &.scene_auth {
      display: block;
      text-align: left;
      align-items: unset;
      justify-content: unset;
      margin-bottom: 16px;
      padding: 0 10px;
    }
    /* 观看端-报名表单 */
    &.scene_signForm {
      display: block;
      text-align: center;
      align-items: unset;
      justify-content: unset;
    }
    /* 发起端-问卷 */
    &.scene_liveQuestion {
      margin: 12px auto 0 auto;
      padding-bottom: 60px;
      display: block;
      text-align: center;
      align-items: unset;
      justify-content: unset;
    }
    /* 手机端样式设置 */
    &.client_mobile {
      span {
        font-size: 24px;
      }
      a {
        font-size: 24px;
        line-height: 40px;
      }
      &.scene_lottery {
        width: 626px;
        margin: 32px auto 0 auto;
        text-align: left;
      }
      &.scene_auth {
        margin-top: 32px;
        margin-bottom: 10px;
        padding: 0 0;
        span {
          font-size: 24px;
        }
        a {
          font-size: 24px;
          line-height: 44px;
        }
      }
      &.scene_signForm {
        margin-top: 32px;
        margin-bottom: 0;
        text-align: left;
      }
      /* wap端 - 短信鉴权 */
      &.scene_smsVerification {
        margin-top: 32px;
        margin-bottom: 10px;
        padding: 0 0;
        span {
          font-size: 24px;
        }
        a {
          font-size: 24px;
          line-height: 44px;
        }
      }
    }
    /* PC端样式设置 */
    &.client_pc {
      span {
        font-size: 12px;
      }
      a {
        font-size: 12px;
        line-height: 20px;
      }
      &.scene_auth {
        padding: 0 0;
      }
      &.scene_lottery {
        width: 100%;
        // text-align: center;
        span {
          font-size: 12px;
          line-height: 17px;
        }
        a {
          font-size: 12px;
          line-height: 17px;
        }
      }
      &.scene_signForm {
        margin-top: 12px;
        margin-bottom: 0;
      }
    }
    &.language__en {
      a {
        font-style: italic;
      }
      &.client_pc {
        &.scene_lottery {
          // width: 278px;
          bottom: 34px;
          padding-left: 0;
        }
      }
      &.client_mobile {
        &.scene_lottery {
          // &.language__en {
          // text-align: center;
          // }
        }
        &.scene_signForm {
          &.language__en {
            text-align: center;
          }
        }
      }
    }
  }
  @media (min-width: 375px) {
    .vmp-privacy-compliance {
      &.client_mobile {
        // &.scene_lottery {
        // text-align: center;
        // }
        &.scene_signForm {
          text-align: center;
        }
      }
    }
  }
</style>
